import { useState, useEffect } from 'react';
import { Modal, Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import MediaFetcher from '../../../ux/Creatives/library/MediaFetcher';

const CreativePreviewModal = ({
  visible,
  onClose,
  images,
  startIndex = 0
}) => {
  const [currentSlide, setCurrentSlide] = useState(startIndex);
  const [currentMedia, setCurrentMedia] = useState(null);

  useEffect(() => {
    if (images && images.length > 0) {
      setCurrentSlide(startIndex);
      setCurrentMedia(images[startIndex]);
    }
  }, [images, startIndex]);

  // Cleanup videos when modal closes
  useEffect(() => {
    if (!visible) {
      const videos = document.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });
    }
  }, [visible]);

  const PrevArrow = ({ onClick }) => (
    <div className="creative-preview-modal__arrow creative-preview-modal__arrow--prev" onClick={onClick}>
      <LeftOutlined />
    </div>
  );

  const NextArrow = ({ onClick }) => (
    <div className="creative-preview-modal__arrow creative-preview-modal__arrow--next" onClick={onClick}>
      <RightOutlined />
    </div>
  );

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onClose}
      footer={null}
      width="80vw"
      centered
      closable={false}
      mask={true}
      maskStyle={{
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        backdropFilter: "blur(3px)"
      }}
      maskClosable={true}
      style={{
        maxWidth: "900px",
        background: "transparent",
        boxShadow: "none"
      }}
      className="creative-preview-modal"
    >
      {/* Ad Unit Name */}
      <div className="creative-preview-modal__badge creative-preview-modal__badge--name">
        {currentMedia?.name || currentMedia?.key || 'Ad Unit'}
      </div>

      {/* Counter at Bottom Center */}
      <div className="creative-preview-modal__badge creative-preview-modal__badge--counter">
        {currentSlide + 1} / {images.length}
      </div>

      {/* Close Button */}
      <div className="creative-preview-modal__close" onClick={onClose}>
        ×
      </div>

      {images.length > 0 && (
        <Carousel
          initialSlide={startIndex}
          arrows={images.length > 1}
          prevArrow={<PrevArrow />}
          nextArrow={<NextArrow />}
          dots={false}
          infinite={images.length > 1}
          afterChange={(currentSlideIndex) => {
            setCurrentSlide(currentSlideIndex);
            setCurrentMedia(images[currentSlideIndex]);
          }}
          style={{ height: "100%", flex: 1 }}
        >
          {images.map((media, index) => (
            <div key={media.id || media.key}>
              <div className="creative-preview-modal__slide">
                <MediaFetcher
                  key={`media-${media.key}-${index}-${currentSlide}`}
                  mediaKey={media.key}
                  width="100%"
                  height="100%"
                  objectFit="contain"
                  style={{ borderRadius: 8, boxShadow: "0 15px 40px rgba(0, 0, 0, 0.4)" }}
                />
              </div>
            </div>
          ))}
        </Carousel>
      )}
    </Modal>
  );
};

export default CreativePreviewModal;
